<template >
    <div class="tile">
        <div class="tile-title">
            <h2>Accepted Currencies</h2>
        </div>
        <div class="tile-content">
            <r-badge
                type="tag"
                class="inline-s"
                :key="currency"
                v-for="currency in gateway.acceptedCurrencies">{{currency}}</r-badge>
        </div>
    </div>
</template>

<script>
    import detailsMixins from './details-mixins';

    export default {
        name: 'accepted-currencies',
        mixins: [detailsMixins],
    };
</script>
